import React from 'react';
import Raven from 'raven-js';
import P from 'prop-types';

import environment from '../utils/environment';
import UncaughtException from './components/UncaughtException';

export class Logger extends React.Component {
   static propTypes = {
      children: P.node
   };

   state = {
      error: null
   };

   constructor(props) {
      super(props);

      if (environment.sentry) Raven.config(environment.sentry).install();
   }

   componentDidCatch(error, errorInfo) {
      this.setState({ error });
      Raven.captureException(error, { extra: errorInfo });
   }

   render() {
      return this.state.error ? <UncaughtException /> : this.props.children;
   }
}

export default Logger;



// WEBPACK FOOTER //
// ./src/ErrorBoundary/ErrorBoundary.js